var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-navigation" },
    [
      _c("div", { staticClass: "navigation-item company-favicon" }, [
        _c("img", { attrs: { src: "/static/favicon.png" } }),
        _vm._v(" "),
        _c("div", { staticClass: "navigation-name" }, [
          _vm._v(_vm._s(_vm.navigationTitle))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "navigation-apps-section" }, [
        !_vm.showSettings
          ? _c(
              "div",
              { staticClass: "navigation-apps navigation-item-width" },
              [
                _c(
                  "div",
                  {
                    staticClass: "navigation-item",
                    class: { "active-app": _vm.activeApp == "apps" },
                    on: {
                      click: function($event) {
                        return _vm.backToApps()
                      }
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "navigation-icons", attrs: { dark: "" } },
                      [_vm._v("icon-home")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "navigation-name" }, [
                      _vm._v(
                        "All " + _vm._s(_vm.tenantInfo.app_label || "Apps")
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showEpalldashboard || _vm.showMsspDashboard
                  ? _c(
                      "div",
                      {
                        staticClass: "navigation-item",
                        class: {
                          "active-app":
                            _vm.activeApp == "all-companies-dashboard" ||
                            _vm.activeApp == "mssp-dashboard"
                        },
                        on: {
                          click: function($event) {
                            return _vm.switchApp({
                              name: _vm.showEpalldashboard
                                ? "all-companies-dashboard"
                                : "mssp-dashboard"
                            })
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "navigation-icons",
                            attrs: { dark: "" }
                          },
                          [_vm._v("icon-dashboard")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "navigation-name" }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.availableApps.length > 0
                  ? _c(
                      "div",
                      { staticClass: "navigation-divider" },
                      _vm._l(_vm.availableApps, function(value) {
                        return _c(
                          "div",
                          {
                            key: value.name,
                            staticClass: "navigation-item",
                            class: {
                              "active-app": _vm.activeApp === value.name
                            },
                            on: {
                              click: function($event) {
                                return _vm.switchApp(value)
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "navigation-icons",
                                attrs: { dark: "" }
                              },
                              [_vm._v(_vm._s(value.icon))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "navigation-name" }, [
                              _vm._v(_vm._s(value.displayName))
                            ])
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.showSettings
          ? _c(
              "div",
              { staticClass: "navigation-settings navigation-item-width" },
              [
                _c(
                  "div",
                  {
                    staticClass: "navigation-item",
                    on: {
                      click: function($event) {
                        _vm.showSettings = !_vm.showSettings
                      }
                    }
                  },
                  [
                    _c("v-icon", { staticClass: "navigation-icons" }, [
                      _vm._v("icon-person")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "navigation-name" }, [
                      _vm._v("Settings")
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      { staticClass: "settings-arrow navigation-icons" },
                      [_vm._v("icon-arrow_right")]
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showSettings
          ? _c(
              "div",
              { staticClass: "navigation-apps navigation-item-width" },
              [
                _c(
                  "div",
                  {
                    staticClass: "navigation-item",
                    class: { "active-app": _vm.showSettings },
                    on: {
                      click: function($event) {
                        _vm.showSettings = !_vm.showSettings
                      }
                    }
                  },
                  [
                    _c("v-icon", { staticClass: "navigation-icons" }, [
                      _vm._v("icon-person")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "navigation-name" }, [
                      _vm._v("Settings")
                    ]),
                    _vm._v(" "),
                    _vm._m(0)
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "navigation-user-item" }, [
                  _c("div", { staticClass: "navigation-user-info" }, [
                    _c(
                      "div",
                      {
                        staticClass: "navigation-user-name",
                        attrs: {
                          title:
                            _vm.userInfo["username"] +
                            "@" +
                            _vm.userInfo["domain"]
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.userInfo["username"] +
                              "@" +
                              _vm.userInfo["domain"]
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "navigation-user-role" }, [
                      _vm._v(
                        _vm._s(
                          _vm.userInfo["is_superadmin"] ? "Super Admin" : "User"
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.userInfo["has_2fa"]
                  ? _c(
                      "div",
                      {
                        staticClass: "navigation-item",
                        on: {
                          click: function($event) {
                            _vm.showModal = true
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("v-icon", { staticClass: "navigation-icons" }, [
                              _vm._v("icon-phonelink_lock")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "navigation-name" }, [
                          _vm._v("Reset 2FA")
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "navigation-item",
                    class: _vm.userInfo["sso_user"] ? "disabled" : "",
                    on: {
                      click: function($event) {
                        _vm.showPasswordModal = true
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("v-icon", { staticClass: "navigation-icons" }, [
                          _vm._v("icon-lock")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "navigation-name" }, [
                      _vm._v("Change Password")
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.userInfo["enable_docspage"] && _vm.pagename != "docs"
                  ? _c(
                      "div",
                      {
                        staticClass: "navigation-divider",
                        on: {
                          click: function($event) {
                            return _vm.backToDocsPage()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "navigation-item" }, [
                          _c(
                            "div",
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "navigation-icons",
                                  attrs: { dark: "" }
                                },
                                [_vm._v("icon-help")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "navigation-name" }, [
                            _vm._v("Constella Docs Home")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "navigation-divider" }, [
                  _c("div", { staticClass: "navigation-item" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "navigation-icons",
                            attrs: { dark: "" }
                          },
                          [_vm._v("icon-settings")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "navigation-divider" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "navigation-item", on: { click: _vm.logout } },
                  [
                    _c(
                      "div",
                      [
                        _c("v-icon", { staticClass: "navigation-icons" }, [
                          _vm._v("icon-logout")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "navigation-name" }, [
                      _vm._v("Logout")
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showModal
        ? _c("modalpopupVue", {
            attrs: { dialogStatus: _vm.showModal },
            on: { close: _vm.closePopup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showBackupCodesModal
        ? _c("backupCodesModal", {
            attrs: { fromHeader: true, dialogStatus: _vm.showBackupCodesModal },
            on: {
              close: function($event) {
                _vm.showBackupCodesModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPasswordModal
        ? _c("changePasswordPopupVue", {
            attrs: { dialogStatus: _vm.showPasswordModal },
            on: {
              close: function($event) {
                _vm.showPasswordModal = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "settings-arrow backarrow" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("arrow_backward")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "navigation-name" }, [
      _c("span", [
        _c(
          "a",
          {
            attrs: {
              href:
                "mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support",
              target: "new"
            }
          },
          [_vm._v("Contact Constella Support")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }